
import Vue from "vue";
import axios from "axios";
import TextInput from "@shared/components/TextInput.vue";
import TextArea from "@shared/components/TextArea.vue";
import SelectInput from "@shared/components/SelectInput.vue";
export default Vue.extend({
  name: "OrderForm",
  components: {
    SelectInput,
    TextArea,
    TextInput,
  },
  data() {
    return {
      info: {
        name: "",
        email: "",
        phone: "",
        street: "",
        zip: "",
        place: "",
        description: "",
      },
      inquiry: "",
      inquiryError: undefined as string | undefined,
      errors: [""],
      isFormSentSuccess: false,
    };
  },
  computed: {
    isDevMode(): boolean {
      return process.env.VUE_APP_ENV === "test";
    },
  },
  methods: {
    save(e: Event) {
      if (!this.checkForm(e)) {
        return;
      }

      let data = {} as any;

      const inquiryId = process.env.VUE_APP_INQUIRYID as string;
      data[inquiryId] = this.inquiry;
      const streetId = process.env.VUE_APP_ADDRESS as string;
      data[streetId] = this.info.street;
      const zipId = process.env.VUE_APP_ZIP as string;
      data[zipId] = this.info.zip;
      const placeId = process.env.VUE_APP_PLACE as string;
      data[placeId] = this.info.place;
      data["recordType"] = process.env.VUE_APP_RECORDTYPE as string;
      data["external"] = 1;
      data["subject"] = `${this.info.name} ønsker hjelp av NettOpp`;

      const postData = Object.assign(data, this.info); // Merge form data with salesforce ids

      const http = axios.create({
        baseURL: process.env.VUE_APP_BACKEND_URL,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      let pd = "";
      Object.keys(postData).forEach((key) => {
        if (pd.length > 1) {
          pd += "&";
        }
        pd += `${key}=${encodeURI(postData[key])}`;
      });

      // @ts-ignore
      this.$gtm.trackEvent({
        event: "submit_nettopp_form",
        category: "Nettopp",
        action: "Fullført leadsskjema",
        label: this.inquiry,
      });

      http.post("", pd).then();

      this.isFormSentSuccess = true;
    },
    checkForm: function (e: Event) {
      this.errors = [];

      if (!this.info.name) {
        this.errors.push("Mangler navn.");
      }
      if (this.info.phone == "") {
        this.errors.push("Mangler telefon.");
      }
      if (this.info.email == "") {
        this.errors.push("Mangler epost.");
      }
      if (this.info.email && this.validateEmail()) {
        this.errors.push("Ikke gyldig epostadresse");
      }
      if (this.inquiry == "") {
        this.errors.push("Du må fylle ut hva det gjelder");
      }
      if (this.info.description == "") {
        this.errors.push("Du må fylle ut hva du trenger hjelp til");
      }

      if (!this.errors.length) {
        return true;
      }
      e.preventDefault();
    },
    validateEmail() {
      return (
        this.info.email &&
        !new RegExp("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$").test(
          this.info.email
        )
      );
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setInquiry: function (evt: any) {
      this.inquiryError = evt.target.value === "" ? "Påkrevd" : undefined;
      this.inquiry = evt.target.value;
    },
  },
});
